@if (zichtbareGroepen().length > 0) {
	@for (groep of zichtbareGroepen(); track groep.messageUUID) {
		<app-bericht-rij [mode]="mode()" [value]="groep" (refresh)="opRijRefresh()"></app-bericht-rij>
	}
	@if (meerBeschikbaar()) {
		<button type="button" class="laad-meer" (click)="laadMeer()">Laad eerdere berichten</button>
	}
} @else {
	<div class="geen-berichten">Geen berichten</div>
}
